import * as React from 'react';
import omit from 'lodash/omit';
import classNames from 'classnames';
import Element from './Element';
import { getPrefixCls } from '../configure';
// eslint-disable-next-line react/prefer-stateless-function
class SkeletonInput extends React.Component {
    constructor() {
        super(...arguments);
        this.renderSkeletonInput = () => {
            const { prefixCls: customizePrefixCls, className, active } = this.props;
            const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
            const otherProps = omit(this.props, ['prefixCls']);
            const cls = classNames(prefixCls, className, `${prefixCls}-element`, {
                [`${prefixCls}-active`]: active,
            });
            return (React.createElement("div", { className: cls },
                React.createElement(Element, Object.assign({ prefixCls: `${prefixCls}-input` }, otherProps))));
        };
    }
    render() {
        return React.createElement(React.Fragment, null, this.renderSkeletonInput());
    }
}
SkeletonInput.defaultProps = {
    size: 'default',
};
export default SkeletonInput;
